import tw from "twin.macro";

export const PrimaryLink = tw.a`cursor-pointer font-bold text-indigo-500 border-b-2 border-transparent hocus:border-indigo-500 hocus:text-indigo-800 transition duration-300`;
